export default "__VITE_ASSET__cMSfKRVU__";